import { useEffect, useState } from "react";

import { updateDeliverySettings } from "../../services/settingsApi";

function DeliverySettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        baseCharge: "",
        perKmCharge: "",
        freeDeliveryAbove: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                baseCharge: settings.baseCharge || "",
                perKmCharge: settings.perKmCharge || "",
                freeDeliveryAbove: settings.freeDeliveryAbove || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateDeliverySettings(formData);

            alert("Delivery settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update delivery settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Delivery Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Base Delivery Charge (₹)</label>

                        <input
                            type="number"
                            name="baseCharge"
                            value={formData.baseCharge}
                            onChange={handleChange}
                            min="0"
                        />

                    </div>

                    <div className="form-group">

                        <label>Per KM Charge (₹)</label>

                        <input
                            type="number"
                            name="perKmCharge"
                            value={formData.perKmCharge}
                            onChange={handleChange}
                            min="0"
                        />

                    </div>

                    <div className="form-group">

                        <label>Free Delivery Above (₹)</label>

                        <input
                            type="number"
                            name="freeDeliveryAbove"
                            value={formData.freeDeliveryAbove}
                            onChange={handleChange}
                            min="0"
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Delivery Settings
                </button>

            </div>

        </form>

    );

}

export default DeliverySettings;